import {
  Box,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Skeleton,
  Stack,
} from '@mui/material';

import { Or2Card } from '@/components/Surface/Or2Card';

export const LoadingPosts = () => (
  <Stack spacing={2}>
    {[...Array(4).keys()].map((i) => (
      <Or2Card key={i}>
        <CardHeader
          avatar={<Skeleton variant="circular" width={60} height={60} />}
          disableTypography
          title={<Skeleton height={26} width={150} />}
          subheader={<Skeleton height={17.5} width={74} />}
          action={
            <Stack direction="row" spacing={2}>
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
          }
        />
        <CardContent>
          <Box sx={{ my: 4 }}>
            {[...Array(1).keys()].map((i) => (
              <Skeleton key={i} height={26} />
            ))}
          </Box>
        </CardContent>
        <Divider />
        <CardActions disableSpacing>
          <Stack spacing={1} sx={{ width: '100%' }}>
            <Stack direction="row" justifyContent="space-between">
              <Chip
                label={<Skeleton height={26} width={58} />}
                avatar={<Skeleton variant="circular" width={24} height={24} />}
              />
              <Skeleton variant="rounded" height={32} width={105} />
              <Stack direction="row" spacing={1}>
                <Skeleton variant="rounded" height={32} width={138} />
                <Skeleton variant="rounded" height={32} width={148} />
              </Stack>
            </Stack>
          </Stack>
        </CardActions>
      </Or2Card>
    ))}
  </Stack>
);
